/**
 * 
 * @param {Object} data Object holding values for line graph
 * @returns Array with series for simple one line graphs
 */
export function seriesValues(data) {
  let list_data = [];
  for (let i in data) {
    list_data.push({
      name: i,
      type: "line",
      data: data[i],
      lineStyle: {
        width: 3,
      },
    });
  }
  list_data.shift();
  return list_data;
}
